import {
   EmailIcon,
   Link,
   LinkSize,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import {
   MedicalDocumentationPasswordDetailsShowModalInterceptor,
   MedicalDocumentationShareForm,
} from '~libs.desktop.shared.medical-documentation';

import { recommendationsTranslationKeys } from '../../../translations';

import { RecommendationsPrintsPatientSendActionEventInterceptor } from './interceptors/RecommendationsPrintsPatientSendActionEventInterceptor';

type RecommendationsSendLinkProps = { patientId: number; visitId: number };

export const RecommendationsSendLink = (props: RecommendationsSendLinkProps): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'sharePatientDocumentation'}
         title={recommendationsTranslationKeys.shareRecommendationsWithPatient}
         content={({ resolve, reject }) => (
            <MedicalDocumentationShareForm
               patientId={props.patientId}
               phoneNumberHelperText={
                  recommendationsTranslationKeys.smsWithPasswordToEncryptedFileWillBeSentToThisNumber
               }
            >
               {({ trigger, handleSubmit: handleMedicalDocumentationShareSubmit }) => {
                  return (
                     <>
                        <ValidateFormEventInterceptor trigger={trigger} silent>
                           <RecommendationsPrintsPatientSendActionEventInterceptor
                              visitId={props.visitId}
                              onMedicalDocumentationShareFormSubmit={handleMedicalDocumentationShareSubmit}
                           >
                              {({ filePassword }) => (
                                 <MedicalDocumentationPasswordDetailsShowModalInterceptor
                                    filePassword={filePassword}
                                    title={recommendationsTranslationKeys.patientRecommendationsWereCreatedAndSent}
                                    successMessage={
                                       recommendationsTranslationKeys.sentRecommendationsToPatientAndSmsMessageWithPassword
                                    }
                                 >
                                    <ModalConfirmButton
                                       label={recommendationsTranslationKeys.actions.send}
                                       onClick={resolve}
                                    />
                                 </MedicalDocumentationPasswordDetailsShowModalInterceptor>
                              )}
                           </RecommendationsPrintsPatientSendActionEventInterceptor>
                        </ValidateFormEventInterceptor>

                        <ModalCancelButton label={recommendationsTranslationKeys.actions.back} onClick={reject} />
                        <ModalCloseButton onClick={reject} />
                     </>
                  );
               }}
            </MedicalDocumentationShareForm>
         )}
         modalWidth={ModalWidth.NORMAL}
         shouldShowModal
         footerItemsHidden
      >
         <Link
            icon={<EmailIcon />}
            testId={'send'}
            size={LinkSize.NORMAL}
            label={recommendationsTranslationKeys.actions.send}
         />
      </ShowModalEventInterceptor>
   );
};
